import {
    useTheme,
    useMediaQuery,
    SxProps,
    TableRow as MuiTableRow,
    TableRowProps,
} from '@mui/material';
import { motion, MotionProps } from 'framer-motion';
import { forwardRef } from 'react';

const tableRowMediaStyle: SxProps = {
    cursor: 'pointer',

    '&:focus-visible': {
        outlineOffset: '-2px',
    },
};

interface IProps extends TableRowProps {
    children?: React.ReactNode;
    disabled?: boolean;
    onClick?(): void;
}

const TableRow = forwardRef<HTMLTableRowElement, IProps>((props, ref) => (
    <MuiTableRow ref={ref} {...props} />
));

const MotionTableRowMedia = motion.create(TableRow);

export const TableRowMedia = ({
    disabled,
    onClick,
    ...other
}: IProps & MotionProps) => {
    const theme = useTheme();
    const isSm = useMediaQuery(theme.breakpoints.up('sm'));

    return (
        <MotionTableRowMedia
            initial="initItemButton"
            sx={[
                tableRowMediaStyle,
                disabled
                    ? { pointerEvents: 'none' }
                    : { pointerEvents: 'initial' },
            ]}
            tabIndex={!!onClick ? 0 : -1}
            whileHover={isSm ? 'hoverItemButton' : undefined}
            onClick={onClick}
            onKeyDown={(e) => {
                if (e.key === 'Enter') onClick?.();
            }}
            {...other}
        />
    );
};
